<template>
  <head>
    <meta charset="utf-8" />
    <title>CBHI | Community-Based Health Insurance</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
      <!-- Begin page -->
      <div id="layout-wrapper">
        <!-- ========== Left Sidebar Start ========== -->
        <NavigationBar/>
        <!-- Left Sidebar End -->

        <!-- ============================================================== -->
        <!-- Start right Content here -->
        <!-- ============================================================== -->
        <div class="main-content">
          <div class="page-content">
            <div class="container-fluid">
              <!-- start page title -->
              <div class="row">
                <div class="col-12">
                  <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Premium Payment Handover Management</h4>
                    <div class="page-title-right">
                      <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item"><a href="javascript: void(0);">Premium Management</a></li>
                        <li class="breadcrumb-item active">Cash Handover</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Dashboard Stats -->
              <div class="row">
                <div class="col-md-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium">Pending Cash Amount</p>
                          <h4 class="mb-0">{{ formatCurrency(stats.pending_amount) }}</h4>
                          <small class="text-muted">{{ stats.pending_transactions }} transactions</small>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                            <span class="avatar-title">
                              <i class="bx bx-money font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium">Handed Over Today</p>
                          <h4 class="mb-0">{{ formatCurrency(stats.handed_over_amount) }}</h4>
                          <small class="text-muted">{{ stats.handed_over_transactions }} transactions</small>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                            <span class="avatar-title">
                              <i class="bx bx-check-circle font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium">Active Collectors</p>
                          <h4 class="mb-0">{{ stats.active_collectors }}</h4>
                          <small class="text-muted">with pending cash</small>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                            <span class="avatar-title">
                              <i class="bx bx-user font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium">Collection Rate</p>
                          <h4 class="mb-0">{{ getCollectionRate() }}%</h4>
                          <small class="text-muted">completion rate</small>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                            <span class="avatar-title">
                              <i class="bx bx-trending-up font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Date Range Filter -->
              <div class="row mb-3">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row g-3 align-items-end">
                        <div class="col-md-3">
                          <label class="form-label">Date From</label>
                          <input v-model="dateFrom" type="date" class="form-control">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Date To</label>
                          <input v-model="dateTo" type="date" class="form-control">
                        </div>
                        <div class="col-md-2">
                          <button @click="loadData" class="btn btn-primary w-100" :disabled="loading">
                            <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
                            <i v-else class="bx bx-search me-1"></i>
                            Apply Filter
                          </button>
                        </div>
                        <div class="col-md-2">
                          <button @click="showHistoryModal = true" class="btn btn-outline-info w-100">
                            <i class="bx bx-history me-1"></i> View History
                          </button>
                        </div>
                        <div class="col-md-2">
                          <button @click="exportCollectorSummary" class="btn btn-outline-success w-100" :disabled="collectors.length === 0">
                            <i class="bx bx-download me-1"></i> Export
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Main Content -->
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-white">
                      <div class="d-flex justify-content-between align-items-center">
                        <h4 class="card-title mb-0">Premium Cash Collectors Summary</h4>
                        <div class="d-flex align-items-center">
                          <span class="badge bg-primary me-2">CBHI Ethiopia</span>
                          <span class="badge bg-light text-dark">{{ dateFrom }} to {{ dateTo }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="card-body">
                      <!-- Alerts -->
                      <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                        <i class="bx bx-check-circle me-2"></i>
                        {{ message }}
                        <button type="button" class="btn-close" @click="clearAlerts"></button>
                      </div>
                      <div v-if="alert.info" class="alert alert-primary alert-dismissible fade show" role="alert">
                        <i class="bx bx-info-circle me-2"></i>
                        {{ message }}
                        <button type="button" class="btn-close" @click="clearAlerts"></button>
                      </div>
                      <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                        <i class="bx bx-error-circle me-2"></i>
                        {{ message }}
                        <button type="button" class="btn-close" @click="clearAlerts"></button>
                      </div>

                      <!-- Collectors Table -->
                      <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                          <thead class="table-light">
                          <tr>
                            <th>Collector Details</th>
                            <th class="text-center">Total Transactions</th>
                            <th class="text-end">Total Amount</th>
                            <th class="text-end">Pending Amount</th>
                            <th class="text-center">Collection Period</th>
                            <th class="text-center">Location</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Actions</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-if="loading">
                            <td colspan="8" class="text-center py-4">
                              <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                              <p class="mt-2 mb-0 text-muted">Loading collector data...</p>
                            </td>
                          </tr>
                          <tr v-else-if="collectors.length === 0">
                            <td colspan="8" class="text-center py-5 text-muted">
                              <i class="bx bx-receipt bx-lg d-block mb-2"></i>
                              <p class="mb-0">No cash collections found for the selected date range</p>
                              <small>Try adjusting the date filter or check if there are any premium cash payments recorded</small>
                            </td>
                          </tr>
                          <tr v-else v-for="collector in collectors" :key="`${collector.collector_name}-${collector.collector_id}`">
                            <td>
                              <div class="d-flex align-items-center">
                                <div class="avatar-sm me-3">
                                    <span class="avatar-title rounded-circle bg-primary text-white">
                                      {{ getInitials(collector.collector_name) }}
                                    </span>
                                </div>
                                <div>
                                  <h6 class="mb-0">{{ collector.collector_name }}</h6>
                                  <small class="text-muted">ID: {{ collector.collector_id }}</small>
                                </div>
                              </div>
                            </td>
                            <td class="text-center">
                              <span class="badge bg-light text-dark fs-6">{{ collector.total_transactions }}</span>
                            </td>
                            <td class="text-end">
                              <strong class="text-primary">{{ formatCurrency(collector.total_amount) }}</strong>
                            </td>
                            <td class="text-end">
                                <span :class="getPendingAmountClass(collector.pending_amount)">
                                  {{ formatCurrency(collector.pending_amount) }}
                                </span>
                            </td>
                            <td class="text-center">
                              <small class="text-muted">
                                {{ formatDateShort(collector.first_transaction_date) }}<br>
                                <i class="bx bx-right-arrow-alt"></i><br>
                                {{ formatDateShort(collector.last_transaction_date) }}
                              </small>
                            </td>
                            <td class="text-center">
                              <small class="text-muted">
                                <div v-if="collector.woreda_name">{{ collector.woreda_name }}</div>
                                <div v-if="collector.zone_name">{{ collector.zone_name }}</div>
                                <div v-if="collector.collection_point">{{ collector.collection_point }}</div>
                              </small>
                            </td>
                            <td class="text-center">
                                <span :class="getCollectorStatusClass(collector.pending_amount)">
                                  {{ getCollectorStatus(collector.pending_amount) }}
                                </span>
                            </td>
                            <td class="text-center">
                              <div class="btn-group btn-group-sm">
                                <button
                                    @click="viewCollectorTransactions(collector)"
                                    class="btn btn-outline-primary"
                                    title="View Transactions"
                                >
                                  <i class="bx bx-list-ul"></i>
                                </button>
                                <button
                                    v-if="collector.pending_amount > 0"
                                    @click="processHandover(collector)"
                                    class="btn btn-outline-success"
                                    title="Process Handover"
                                >
                                  <i class="bx bx-check-circle"></i>
                                </button>
                                <button
                                    @click="viewCollectorDetails(collector)"
                                    class="btn btn-outline-info"
                                    title="Collector Details"
                                >
                                  <i class="bx bx-user"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- container-fluid -->
          </div>
          <!-- End Page-content -->

          <footer class="footer">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6">© CBHI Ethiopia</div>
                <div class="col-sm-6">
                  <div class="text-sm-end d-sm-block">
                    Ministry of Health - Ethiopia
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
        <!-- end main content-->
      </div>
      <!-- END layout-wrapper -->

      <!-- Transaction Details Modal -->
      <PremiumTransactionDetailsModal
          :show="showTransactionModal"
          :collector="selectedCollector"
          :date-from="dateFrom"
          :date-to="dateTo"
          @close="showTransactionModal = false"
          @handover-processed="onHandoverProcessed"
      />

      <!-- Handover History Modal -->
      <PremiumHandoverHistoryModal
          :show="showHistoryModal"
          @close="showHistoryModal = false"
      />

      <!-- Right bar overlay-->
      <div class="rightbar-overlay"></div>

  </body>
</template>



<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import PremiumTransactionDetailsModal from "@/components/cbhi-collector-handover//modals/PremiumTransactionDetailsModal.vue";
import PremiumHandoverHistoryModal from "@/components/cbhi-collector-handover/modals/PremiumHandoverHistoryModal.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";
import PaymentDetailsModal from "@/components/cbhi-member-management/premiums/modals/PaymentDetailsModal.vue";

export default {
  name: "PremiumHandoverManagement",
  components: {
    PaymentDetailsModal,
    NavigationBar,
    PremiumTransactionDetailsModal,
    PremiumHandoverHistoryModal
  },
  data() {
    return {
      // Loading states
      loading: false,

      // Date range - default to last 7 days
      dateFrom: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      dateTo: new Date().toISOString().split('T')[0],

      // Data
      collectors: [],
      stats: {
        pending_amount: 0,
        pending_transactions: 0,
        handed_over_amount: 0,
        handed_over_transactions: 0,
        active_collectors: 0
      },

      // Modals
      showTransactionModal: false,
      showHistoryModal: false,
      selectedCollector: null,

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    };
  },

  mounted() {
    this.checkAuth();
    this.loadData();
  },

  methods: {
    checkAuth() {
      const token = localStorage.getItem("authToken");
      if (!token) {
        router.push('/login');
      }
    },

    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      // Auto-hide success and info alerts
      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    },

    async loadData() {
      await Promise.all([
        this.loadStats(),
        this.loadCollectors()
      ]);
    },

    async loadStats() {
      const data = {
        "function": "getPremiumHandoverStats",
        "dateFrom": this.dateFrom,
        "dateTo": this.dateTo
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.stats = res.data.data;
        }
      } catch (e) {
        console.error("Failed to load stats:", e);
      }
    },

    async loadCollectors() {
      this.loading = true;

      const data = {
        "function": "getPremiumCollectorSummary",
        "dateFrom": this.dateFrom,
        "dateTo": this.dateTo
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.collectors = res.data.data.collectors || [];
        } else {
          this.showAlert('failed', res.data.message || 'Failed to load collectors data');
        }
      } catch (e) {
        this.showAlert('failed', e.message || 'Failed to load collectors data');
        console.error("Failed to load collectors:", e);
      } finally {
        this.loading = false;
      }
    },

    viewCollectorTransactions(collector) {
      this.selectedCollector = collector;
      this.showTransactionModal = true;
    },

    processHandover(collector) {
      this.selectedCollector = collector;
      this.showTransactionModal = true;
    },

    viewCollectorDetails(collector) {
      // Could open a detailed view or navigate to collector profile
      this.showAlert('info', `Viewing details for ${collector.collector_name}`);
    },

    onHandoverProcessed(data) {
      this.showTransactionModal = false;
      this.selectedCollector = null;
      this.loadData(); // Refresh data
      this.showAlert('success', `Handover processed successfully! Reference: ${data.handover_reference}`);
    },

    exportCollectorSummary() {
      try {
        // Prepare CSV data
        const headers = [
          'Collector Name',
          'Collector ID',
          'Total Transactions',
          'Total Amount (ETB)',
          'Pending Amount (ETB)',
          'Handed Over Amount (ETB)',
          'First Transaction Date',
          'Last Transaction Date',
          'Woreda',
          'Zone',
          'Collection Point'
        ];

        const csvData = [
          headers.join(','),
          ...this.collectors.map(c => [
            `"${c.collector_name}"`,
            c.collector_id,
            c.total_transactions,
            c.total_amount,
            c.pending_amount,
            c.handed_over_amount,
            c.first_transaction_date,
            c.last_transaction_date,
            `"${c.woreda_name || ''}"`,
            `"${c.zone_name || ''}"`,
            `"${c.collection_point || ''}"`
          ].join(','))
        ].join('\n');

        // Download CSV
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `premium_collectors_summary_${this.dateFrom}_to_${this.dateTo}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.showAlert('success', 'Collector summary exported successfully');
      } catch (e) {
        this.showAlert('failed', 'Failed to export data');
      }
    },

    // Utility methods
    getInitials(name) {
      if (!name) return 'N/A';
      return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
    },

    formatCurrency(amount) {
      if (!amount || amount === 0) return 'ETB 0.00';
      return 'ETB ' + parseFloat(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    formatDateShort(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    },

    getPendingAmountClass(amount) {
      if (amount > 0) {
        return 'text-warning fw-bold fs-6';
      }
      return 'text-success fw-bold';
    },

    getCollectorStatus(pendingAmount) {
      return pendingAmount > 0 ? 'Pending Handover' : 'All Handed Over';
    },

    getCollectorStatusClass(pendingAmount) {
      return pendingAmount > 0 ? 'badge bg-warning text-dark' : 'badge bg-success';
    },

    getCollectionRate() {
      const total = this.stats.pending_amount + this.stats.handed_over_amount;
      if (total === 0) return 0;
      return Math.round((this.stats.handed_over_amount / total) * 100);
    }
  }
};
</script>

<style scoped>
.mini-stats-wid .card-body {
  padding: 1.5rem;
}

.mini-stat-icon {
  width: 48px;
  height: 48px;
}

.table th {
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
}

.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
}

.badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}

.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 0.9rem;
  font-weight: 600;
}

.table-responsive {
  border-radius: 0.375rem;
}

.alert {
  border: none;
  border-radius: 0.5rem;
}

.fs-6 {
  font-size: 0.875rem !important;
}

@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.8rem;
  }

  .btn-group-sm > .btn {
    padding: 0.2rem 0.4rem;
  }

  .avatar-sm {
    width: 2rem;
    height: 2rem;
  }

  .mini-stats-wid .card-body {
    padding: 1rem;
  }
}
</style>